class SessionStorage {
	clear() {
		sessionStorage.clear();
	}

	clearPath(key) {
		sessionStorage.removeItem(key);
	}

	setAuthObj(obj) {
		try {
			if (obj) {
				const authObj = JSON.stringify(obj);
				sessionStorage.setItem("authObj", authObj);
			}
			return true;
		} catch (err) {
			console.log("setAuthObj err: ", err);
			return false;
		}
	}

	setPathName(key, value) {
		try {
			sessionStorage.setItem(key, value);
			return true;
		} catch (err) {
			console.log("Session storage - setPathName err: ", err);
			return false;
		}
	}

	getAuthObj() {
		try {
			const value = sessionStorage.getItem("authObj");
			return value ? JSON.parse(value) : null;
		} catch (err) {
			console.log("getAuthObj err: ", err);
			return null;
		}
	}

	getPathName(key) {
		try {
			return sessionStorage.getItem(key);
		} catch (err) {
			console.log("getPathName err: ", err);
			return null;
		}
	}

	setUtilizationData(obj) {
		try {
			if (obj) {
				const googleAuthObj = JSON.stringify(obj);
				sessionStorage.setItem("setUtilizationData", googleAuthObj);
			}
			return true;
		} catch (err) {
			console.log("setUtilizationData err: ", err);
			return false;
		}
	}
}

export default new SessionStorage();
